import { useRef } from 'react';

/**
 * useDragResize
 * @param {object} options - Configuration object:
 * @param {function} [options.onResizeX] - Callback for horizontal resize (newX: number).
 * @param {function} [options.onResizeY] - Callback for vertical resize (newY: number).
 * @param {function} [options.getCurrentX] - Returns current X value at drag start.
 * @param {function} [options.getCurrentY] - Returns current Y value at drag start.
 * @param {boolean} [options.enableX=true] - Enable horizontal resizing.
 * @param {boolean} [options.enableY=false] - Enable vertical resizing.
 * @returns {object} { onMouseDown }
 */
export const useDragResize = ({
  onResizeX,
  onResizeY,
  getCurrentX = () => 0,
  getCurrentY = () => 0,
  enableX = true,
  enableY = true,
}) => {
  const dragging = useRef(false);

  const onMouseDown = (e) => {
    e.preventDefault();
    dragging.current = true;
    const startX = e.clientX;
    const startY = e.clientY;
    const startValX = getCurrentX();
    const startValY = getCurrentY();

    const onMouseMove = (moveEvent) => {
      if (!dragging.current) return;

      if (enableX && onResizeX) {
        const deltaX = moveEvent.clientX - startX;
        onResizeX(startValX + deltaX);
      }

      if (enableY && onResizeY) {
        const deltaY = moveEvent.clientY - startY;
        onResizeY(startValY + deltaY);
      }
    };

    const onMouseUp = () => {
      dragging.current = false;
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseup', onMouseUp);
    };

    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mouseup', onMouseUp);
  };

  return { onMouseDown };
};

export default useDragResize;
